import { routes as routesShares } from "@DataSharing/Shares/routes";

export const routes = [
    ...routesShares,
]
